// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file aggregate/v1/aggregate_api.proto (package aggregate.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { GetCompanyProjectAggregateUsersRequest, GetCompanyProjectAggregateUsersResponse, GetCompanyProjectsAggregateRequest, GetCompanyProjectsAggregateResponse, GetCompanyProjectsTasksAggregateRequest, GetCompanyProjectsTasksAggregateResponse, GetCompanyUserAndProjectsRequest, GetCompanyUserAndProjectsResponse, GetUserAggregateProfileRequest, GetUserAggregateProfileResponse } from "./aggregate_api_pb.js";

/**
 * @generated from rpc aggregate.v1.AggregateAPI.GetUserAggregateProfile
 */
export const getUserAggregateProfile = {
  localName: "getUserAggregateProfile",
  name: "GetUserAggregateProfile",
  kind: MethodKind.Unary,
  I: GetUserAggregateProfileRequest,
  O: GetUserAggregateProfileResponse,
  service: {
    typeName: "aggregate.v1.AggregateAPI"
  }
} as const;

/**
 * @generated from rpc aggregate.v1.AggregateAPI.GetCompanyProjectAggregateUsers
 */
export const getCompanyProjectAggregateUsers = {
  localName: "getCompanyProjectAggregateUsers",
  name: "GetCompanyProjectAggregateUsers",
  kind: MethodKind.Unary,
  I: GetCompanyProjectAggregateUsersRequest,
  O: GetCompanyProjectAggregateUsersResponse,
  service: {
    typeName: "aggregate.v1.AggregateAPI"
  }
} as const;

/**
 * @generated from rpc aggregate.v1.AggregateAPI.GetCompanyProjectsAggregate
 */
export const getCompanyProjectsAggregate = {
  localName: "getCompanyProjectsAggregate",
  name: "GetCompanyProjectsAggregate",
  kind: MethodKind.Unary,
  I: GetCompanyProjectsAggregateRequest,
  O: GetCompanyProjectsAggregateResponse,
  service: {
    typeName: "aggregate.v1.AggregateAPI"
  }
} as const;

/**
 * @generated from rpc aggregate.v1.AggregateAPI.GetCompanyProjectsTasksAggregate
 */
export const getCompanyProjectsTasksAggregate = {
  localName: "getCompanyProjectsTasksAggregate",
  name: "GetCompanyProjectsTasksAggregate",
  kind: MethodKind.Unary,
  I: GetCompanyProjectsTasksAggregateRequest,
  O: GetCompanyProjectsTasksAggregateResponse,
  service: {
    typeName: "aggregate.v1.AggregateAPI"
  }
} as const;

/**
 * @generated from rpc aggregate.v1.AggregateAPI.GetCompanyUserAndProjects
 */
export const getCompanyUserAndProjects = {
  localName: "getCompanyUserAndProjects",
  name: "GetCompanyUserAndProjects",
  kind: MethodKind.Unary,
  I: GetCompanyUserAndProjectsRequest,
  O: GetCompanyUserAndProjectsResponse,
  service: {
    typeName: "aggregate.v1.AggregateAPI"
  }
} as const;
